export default function (path, dimensions, handle, {width, height, tipWidth} = {}) {
  height = Math.max(height != null ? height : (dimensions.width - handle[0] * dimensions.width), 0)
  width = Math.max(width || ((dimensions.center[1] - (dimensions.height * handle[1])) * 2), 0)

  // By default the full width of the arrow is the base width (i.e. width) * 2.
  // Can be overrriden
  tipWidth = tipWidth || width * 2

  const draw =  (start, direction, _dimensions, tipLock, end = start) => {
    const bounds = _dimensions || dimensions

    path.lineTo(...start)

    let center = null

    switch (direction) {
      case 'east':
        center = start[1] + width / 2
        path.lineTo(bounds.width - height, center - width / 2)
        path.lineTo(bounds.width - height, center - tipWidth / 2)
        path.lineTo(...(tipLock || [bounds.width, center]))
        path.lineTo(bounds.width - height, center + tipWidth / 2)
        path.lineTo(bounds.width - height, center + width / 2)
        path.lineTo(end[0], end[1] + width)
        break
      case 'south':
        center = start[0] - width / 2
        path.lineTo(center + width / 2, bounds.height - height)
        path.lineTo(center + tipWidth / 2, bounds.height - height)
        path.lineTo(...(tipLock || [center,  bounds.height]))
        path.lineTo(center - tipWidth / 2, bounds.height - height)
        path.lineTo(center - width / 2, bounds.height - height)
        path.lineTo(end[0] - width, end[1])
        break
      case 'west':
        center = start[1] - width / 2
        path.lineTo(height, center + width / 2)
        path.lineTo(height, center + tipWidth / 2)
        path.lineTo(...(tipLock || [0, center]))
        path.lineTo(height, center - tipWidth / 2)
        path.lineTo(height, center - width / 2)
        path.lineTo(end[0], end[1] - width)
        break
      case 'north':
        center = start[0] + width / 2
        path.lineTo(center - width / 2, height)
        path.lineTo(center - tipWidth / 2, height)
        path.lineTo(...(tipLock || [center, 0]))
        path.lineTo(center + tipWidth / 2, height)
        path.lineTo(center + width / 2, height)
        path.lineTo(end[0] + width, end[1])
        break
    }
  }

  draw.width = width // arrow base width
  draw.height = height

  return draw
}
